import { createFileRoute } from "@tanstack/react-router";

interface MapEditorSearchParams {
  poi?: string; // POI ID to open in detail sheet
  mode?: "create_poi" | "stamp" | "delete" | "scatter"; // Mode to auto-activate
  returnTo?: string; // Route to return to (e.g., "pois")
}

const VALID_MODES = ["create_poi", "stamp", "delete", "scatter"] as const;

export const Route = createFileRoute("/$orgSlug/admin/map/$mapSlug")({
  validateSearch: (search: Record<string, unknown>): MapEditorSearchParams => ({
    poi: typeof search.poi === "string" ? search.poi : undefined,
    mode: VALID_MODES.includes(search.mode as typeof VALID_MODES[number])
      ? (search.mode as typeof VALID_MODES[number])
      : undefined,
    returnTo: typeof search.returnTo === "string" ? search.returnTo : undefined,
  }),
  // Component moved to $orgSlug.admin.map.$mapSlug.lazy.tsx for code splitting
  // This is critical - the map editor includes Geoman (~300KB) which should only load for admins
});
